import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45ccc35d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checklist-item" }
const _hoisted_2 = { class: "check-box-display" }
const _hoisted_3 = { class: "checklist-item-text" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}

import { ref } from 'vue';
import { ChecklistItemComposable } from '../../../../ecs/completable/Completable';
import InteractiveCheckBox from '../../../InteractiveCheckBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistItemComponent',
  props: {
    item: null,
    complete: { type: Boolean },
    active: { type: Boolean },
    userSelectedActive: { type: Boolean },
    userSelectedComplete: { type: Boolean },
    compromised: { type: Boolean },
    description: null,
    subtitle: null
  },
  setup(__props: any) {

const props = __props as {
  item: ChecklistItemComposable;
  complete: boolean;
  active: boolean;
  userSelectedActive: boolean;
  userSelectedComplete: boolean;
  compromised: boolean;
  description: string;
  subtitle: string;
}



const showDropdown = ref(false);

const handleBodyClick = () => {
  showDropdown.value = !showDropdown.value;
};

const handleDropdownItemClick = (value: 'complete' | 'active') => {
  if (value === 'complete') {
    props.item.setComplete(true);
  } else if (value === 'active') {
    props.item.setActive(true);
  }
  showDropdown.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(InteractiveCheckBox, {
          complete: __props.complete,
          active: __props.active,
          "user-selected-active": __props.userSelectedActive,
          "user-selected-complete": __props.userSelectedComplete,
          "show-dropdown": showDropdown.value,
          compromised: __props.compromised,
          onBodyClick: handleBodyClick,
          onDropdownItemClick: handleDropdownItemClick
        }, null, 8, ["complete", "active", "user-selected-active", "user-selected-complete", "show-dropdown", "compromised"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(__props.description), 1),
        (__props.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.subtitle), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})